import { PlaceholdersId, TFComponent } from '@types';

import { IntroPlaceholder } from './intro';

export const intro: TFComponent = {
	component: IntroPlaceholder,
	id: PlaceholdersId.intro,
	name: 'intro',
};
